// file: NavigationData.js
// Configuration-driven navigation data.
// Each item: { id, title, icon (Google Material Symbols name), link, match, children }
// SideNav only renders this data — it does not decide which array to use.
// The parent (e.g. AdminDashboard) picks the array based on role and passes it down.

export const adminNavigations = [
  {
    numId: "1",
    id: "dashboard",
    title: "Dashboard",
    icon: "dashboard",
    link: "/dashboard",
    match: "exact",
    children: [],
  },
  // Remaining nav items disabled until their pages are built. Uncomment as
  // each one ships.
  // {
  //   numId: "2",
  //   id: "task",
  //   title: "Tasks",
  //   icon: "task",
  //   link: "/dashboard/tasks",
  //   children: [],
  // },
  // {
  //   numId: "3",
  //   id: "tickets",
  //   title: "Tickets",
  //   icon: "confirmation_number",
  //   link: "/dashboard/tickets",
  //   children: [],
  // },
  // {
  //   numId: "4",
  //   id: "reports",
  //   title: "Reports",
  //   icon: "lab_profile",
  //   link: "/dashboard/reports",
  //   children: [],
  // },
  // {
  //   numId: "5",
  //   id: "projects",
  //   title: "Projects",
  //   icon: "assignment_turned_in",
  //   link: "/dashboard/projects",
  //   children: [],
  // },
  // {
  //   numId: "6",
  //   id: "accessControl",
  //   title: "Access Control",
  //   icon: "shield_locked",
  //   link: "/dashboard/access-control",
  //   children: [],
  // },
  // {
  //   numId: "7",
  //   id: "leave",
  //   title: "Leave",
  //   icon: "event_available",
  //   link: "/dashboard/leave",
  //   children: [],
  // },
  // {
  //   numId: "8",
  //   id: "eod",
  //   title: "EOD",
  //   icon: "eod",
  //   link: "/dashboard/eod",
  //   children: [],
  // },
];

export const manufacturerNavigations = [
  { numId: "1", id: "dashboard", title: "Dashboard", icon: "dashboard", link: "/dashboard", match: "exact", children: [] },
  { numId: "2", id: "brands", title: "Brands", icon: "store", link: "/dashboard/brands", children: [] },
  { numId: "3", id: "engagements", title: "Engagements", icon: "handshake", link: "/dashboard/engagements", children: [] },
  { numId: "4", id: "wallets", title: "Wallets & Ledger", icon: "account_balance_wallet", link: "/dashboard/wallets", children: [] },
  { numId: "5", id: "receipts", title: "Payment Receipts", icon: "confirmation_number", link: "/dashboard/receipts", children: [] },
  { numId: "6", id: "requirements", title: "Requirements", icon: "assignment", link: "/dashboard/requirements", children: [] },
  { numId: "7", id: "fabrics", title: "Fabrics", icon: "texture", link: "/dashboard/fabrics", children: [] },
  { numId: "8", id: "designs", title: "Designs", icon: "palette", link: "/dashboard/designs", children: [] },
  { numId: "9", id: "board", title: "Task Board", icon: "view_kanban", link: "/dashboard/board", children: [] },
  { numId: "10", id: "orders", title: "Orders", icon: "shopping_cart", link: "/dashboard/orders", children: [] },
  { numId: "11", id: "documents", title: "Documents", icon: "folder", link: "/dashboard/documents", children: [] },
  { numId: "12", id: "notifications", title: "Notifications", icon: "notifications", link: "/dashboard/notifications", children: [] },
  { numId: "13", id: "reports", title: "Reports", icon: "bar_chart", link: "/dashboard/reports", children: [] },
  { numId: "14", id: "users", title: "Users & Roles", icon: "people", link: "/dashboard/users", children: [] },
  { numId: "15", id: "audit", title: "Audit Log", icon: "history", link: "/dashboard/audit", children: [] },
  { numId: "16", id: "settings", title: "Settings", icon: "settings", link: "/dashboard/settings", children: [] },
];

export const CompanyAdminNavigations = manufacturerNavigations;

export const brandNavigations = [
  { numId: "1", id: "dashboard", title: "Dashboard", icon: "dashboard", link: "/brand", match: "exact", children: [] },
  { numId: "2", id: "manufacturers", title: "Manufacturers", icon: "store", link: "/brand/manufacturers", children: [] },
  { numId: "3", id: "engagements", title: "Engagements", icon: "handshake", link: "/brand/engagements", children: [] },
  { numId: "4", id: "wallet", title: "Wallets & Ledger", icon: "account_balance_wallet", link: "/brand/wallet", children: [] },
  { numId: "5", id: "receipts", title: "Payment Receipts", icon: "confirmation_number", link: "/brand/receipts", children: [] },
  { numId: "6", id: "requirements", title: "Requirements", icon: "assignment", link: "/brand/requirements", children: [] },
  { numId: "7", id: "fabrics", title: "Fabrics", icon: "texture", link: "/brand/fabrics", children: [] },
  { numId: "8", id: "designs", title: "Designs", icon: "palette", link: "/brand/designs", children: [] },
  { numId: "9", id: "board", title: "Task Board", icon: "view_kanban", link: "/brand/board", children: [] },
  { numId: "10", id: "orders", title: "Orders", icon: "shopping_cart", link: "/brand/orders", children: [] },
  { numId: "11", id: "documents", title: "Documents", icon: "folder", link: "/brand/documents", children: [] },
  { numId: "12", id: "notifications", title: "Notifications", icon: "notifications", link: "/brand/notifications", children: [] },
  { numId: "13", id: "reports", title: "Reports", icon: "bar_chart", link: "/brand/reports", children: [] },
  { numId: "14", id: "team", title: "Brand Team", icon: "people", link: "/brand/team", children: [] },
  { numId: "15", id: "audit", title: "Audit History", icon: "history", link: "/brand/audit", children: [] },
  { numId: "16", id: "settings", title: "Brand Settings", icon: "settings", link: "/brand/settings", children: [] },
];


// Options list for Permission multi-select dropdown in Add/Edit Role form
export const PERMISSION_DROPDOWN_OPTIONS = [
  { id: "1", label: "Dashboard", title: "Dashboard", icon: "dashboard" },
  { id: "2", label: "Tasks", title: "Tasks", icon: "task" },
  { id: "2_delete", label: "Tasks - Delete Task", title: "Delete Task", icon: "delete", parentId: "2" },
  { id: "3", label: "Tickets", title: "Tickets", icon: "confirmation_number" },
  { id: "3_delete", label: "Tickets - Delete Ticket", title: "Delete Ticket", icon: "delete", parentId: "3" },
  { id: "4", label: "Reports", title: "Reports", icon: "lab_profile" },
  { id: "5", label: "Projects", title: "Projects", icon: "assignment_turned_in" },
  { id: "5_create", label: "Projects - Add Project", title: "Add Project", icon: "add_circle", parentId: "5" },
  { id: "5_edit", label: "Projects - Edit Project", title: "Edit Project", icon: "edit", parentId: "5" },
  { id: "5_delete", label: "Projects - Delete Project", title: "Delete Project", icon: "delete", parentId: "5" },
  { id: "6", label: "Access Control", title: "Access Control", icon: "shield_locked" },
  { id: "6_create", label: "Access Control - Create", title: "Create Access Control", icon: "add_circle", parentId: "6" },
  { id: "6_edit", label: "Access Control - Edit", title: "Edit Access Control", icon: "edit", parentId: "6" },
  { id: "6_delete", label: "Access Control - Delete", title: "Delete Access Control", icon: "delete", parentId: "6" },
  { id: "7", label: "Leave", title: "Leave", icon: "event_available" },
  { id: "8", label: "EOD", title: "EOD", icon: "eod" },
  { id: "8_view_all", label: "EOD - View All Users Reports", title: "View All Users Reports", icon: "group", parentId: "8" },
];

// Helper to construct the accessControl object for POST/PUT /api/roles API payload
// based on selected navigation item IDs and action IDs
export const buildAccessControlFromSelectedIds = (selectedIds = []) => {
  const map = {};
  adminNavigations.forEach((item, index) => {
    const key = String(item.numId || index + 1);
    const hasAccess =
      selectedIds?.includes(key) || selectedIds?.includes(item.id);

    const actions = {};
    if (key === "2" || item.id === "task") {
      actions.canDelete = selectedIds.includes("2_delete");
    }
    if (key === "3" || item.id === "tickets") {
      actions.canDelete = selectedIds.includes("3_delete");
    }
    if (key === "5" || item.id === "projects") {
      actions.canCreate = selectedIds.includes("5_create");
      actions.canEdit = selectedIds.includes("5_edit");
      actions.canDelete = selectedIds.includes("5_delete");
    }
    if (key === "6" || item.id === "accessControl") {
      actions.canCreate = selectedIds.includes("6_create");
      actions.canEdit = selectedIds.includes("6_edit");
      actions.canDelete = selectedIds.includes("6_delete");
    }
    if (key === "8" || item.id === "eod") {
      actions.canViewAll = selectedIds.includes("8_view_all");
    }

    map[key] = {
      icon: item.icon || "dashboard",
      link: item.link || "",
      title: item.title,
      children: item.children || [],
      hasAccess: Boolean(hasAccess),
      actions,
    };
  });
  return map;
};

export const buildAccessControlMap = (navigations = adminNavigations, customAccess = {}) => {
  const map = {};
  navigations.forEach((item, index) => {
    const key = String(item.numId || index + 1);
    const existing = customAccess?.[key] || customAccess?.[item.id];
    map[key] = {
      title: item.title,
      icon: item.icon || "dashboard",
      link: item.link || "",
      children: item.children || [],
      hasAccess: existing?.hasAccess ?? true,
    };
  });
  return map;
};

// Filter navigations according to a user's role accessControl configuration
export const filterNavigationsByAccessControl = (navigations = adminNavigations, accessControl) => {
  if (!accessControl || typeof accessControl !== "object" || Object.keys(accessControl).length === 0) {
    return navigations;
  }

return navigations.filter((item) => {
  const numIdKey = String(item.numId);
  if (accessControl[numIdKey] !== undefined) {
    return Boolean(accessControl[numIdKey]?.hasAccess);
  }
  if (accessControl[item.id] !== undefined) {
    return Boolean(accessControl[item.id]?.hasAccess);
  }
  const matchingVal = Object.values(accessControl).find(
    (val) =>
      (val?.title && val.title.toLowerCase() === item.title.toLowerCase()) ||
      (val?.link && item.link && val.link.toLowerCase() === item.link.toLowerCase())
  );
  if (matchingVal !== undefined) {
    return Boolean(matchingVal.hasAccess);
  }
  return true;
});
};

// Generic link matcher driven entirely by an item's own `link`/`match`
// fields — shared by SideNav (active highlight) and AdminDashboard
// (page heading) so the matching rule only lives in one place.
export const isLinkActive = (pathname, item) => {
  if (!item?.link) return false;
  if (item.match === "exact" || item.link === "/") {
    return pathname === item.link;
  }
  return pathname === item.link || pathname.startsWith(`${item.link}/`);
};

// Walks a navigations array (including children) and returns the item
// whose link matches the given pathname, or undefined if none match.
// Children are checked first so a specific child route always wins over
// its parent's own (broader, prefix-matching) link.
export const findActiveNavItem = (navigations, pathname) => {
  for (const item of navigations) {
    const activeChild = item.children?.find((child) =>
      isLinkActive(pathname, child)
    );
    if (activeChild) return activeChild;
    if (isLinkActive(pathname, item)) return item;
  }
  return undefined;
};
